import { useEffect, useRef } from "react";
import ReactDOMServer from "react-dom/server";

/**
 * TODO: deprecate this. this is not really optimizing anything, it is just
 * deferring work to the next frame.
 *
 * PLEASE USE `useLazyTooltip` instead, which will actually defer work until
 * the latest possible moment!
 */
export default function useDeferredTooltip(tooltip: React.ReactElement) {
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    if (ref.current?.nodeType !== Node.ELEMENT_NODE) return;
    const id = setTimeout(() => {
      const renderedTooltip = ReactDOMServer.renderToStaticMarkup(tooltip);
      ref.current?.setAttribute("data-tip", renderedTooltip);
    });
    return () => {
      clearTimeout(id);
    };
  });
  return ref;
}
